import { getBrandFocusRing } from '../focus';
export const menu = (theme) => ({
    background: theme.colors?.component?.elevated,
    borderColor: theme.colors?.border.subtle,
    titleColor: theme.colors?.text.basic.tertiary,
    item: {
        background: 'inherit',
        color: theme.colors?.text.basic.primary,
        '&:hover': {
            background: theme.colors?.component?.alt?.hover,
            color: theme.colors?.text.basic.primary,
        },
        '&:active': {
            background: theme.colors?.component.active,
            color: theme.colors?.text.basic.primary,
        },
        '&:focus-visible': {
            outline: 'none',
            background: 'transparent',
            boxShadow: getBrandFocusRing(theme, true),
        },
        '&:disabled': {
            background: theme.colors?.surface.elevated,
            color: theme.colors?.text.basic.disabled,
            cursor: 'not-allowed',
        },
    },
    selectedItem: {
        background: theme.colors?.component?.brandLight?.default,
        color: theme.colors?.text?.brand,
        borderWidth: 0,
        boxShadow: '0',
        '&:hover': {
            background: theme.colors?.component?.brandLight?.hover,
        },
        '&:active': {
            background: theme.colors?.component?.brandLight?.active,
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: getBrandFocusRing(theme, true),
        },
        '&:disabled': {
            color: theme.colors?.text?.basic?.disabled,
            background: theme.colors?.component?.disabled,
            cursor: 'not-allowed',
        },
    },
    icon: {
        color: theme.colors?.text.basic.secondary,
    },
});
//# sourceMappingURL=menu.js.map